import { AddEdit } from '../../../../../interfaces/user.interface';
import { Validation } from '../../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING, APP_ERROR_MESSAGES, Regex } from "../../../../../utils/appConstant"

export const validateAddEditForm = (formData: AddEdit, fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] }
  
  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.firstName) {
    if(!formData.firstName.trim()) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.firstName, message: APP_ERROR_MESSAGES.users.addEdit.blankFirstName }) }
  }
    
  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.lastName) {
    if(!formData.lastName.trim()) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.lastName, message: APP_ERROR_MESSAGES.users.addEdit.blankLastName }) }
  }

  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.email) {
    if(!formData.email?.trim()) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.email, message: APP_ERROR_MESSAGES.users.addEdit.blankEmail }) }
    else if (!Regex.email.test(formData.email.trim())) {
      validations.validate = false;
      validations.fields.push({ field: VALIDATION_FIELD_MAPPING.email, message: APP_ERROR_MESSAGES.users.addEdit.invalidEmail })
    }
  }

  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.phoneNumber) {
    if(!formData.phoneNumber.trim()) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.phoneNumber, message: APP_ERROR_MESSAGES.users.addEdit.blankPhoneNumber }) }
  }

  if(!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.role) {
    if(!formData.role) { validations.validate = false; validations.fields.push({ field: VALIDATION_FIELD_MAPPING.role, message: APP_ERROR_MESSAGES.users.addEdit.blankRole }) }
  }
  
  return validations
}